import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { mergeMap, throttleTime } from 'rxjs/operators';
import { showNotificationThunk } from 'state/notifications/notification.thunk';
import type { EpicWithThunk } from 'state/state.common';

export default function unhandledErrorEpic(): EpicWithThunk {
  return (actions$, _state$, { frontLogger }) =>
    actions$.pipe(
      ofType('UNHANDLED_ERROR'),
      throttleTime(30_000),
      mergeMap(({ message, error, epicName }) => {
        frontLogger.error('generic error in {epicName}: {@FrontError}', epicName, error);
        return of(showNotificationThunk({ level: 'danger', title: { id: 'toast.internalError' }, content: [message] }));
      }),
    );
}
